import { render, staticRenderFns } from "./ModalEliminarCertificado.vue?vue&type=template&id=9fd287b4&scoped=true&"
import script from "./ModalEliminarCertificado.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd287b4",
  null
  
)

export default component.exports